








































































































































































































































































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import YcColorPicker from "@/components/color-picker/index.js";
import {
  formAddList
} from '../../../constant/options';
import { getFontFaceList } from "@/utils/getFontFaceList";

@Component({
  components: {
    "yc-color-picker": YcColorPicker,
  },
})
export default class wheelOfFortuneTextEnd extends Vue {

  @Prop(String)
  activePageSetting!:string;

  @Prop(Object)
  formData!:object;


  formDataStart: any = this.formData


  collapseArr =  ['1','2']

  formList = this.formData.end

  predefineColors = [
    '#ff4500',
    '#ff8c00',
    '#ffd700',
    '#90ee90',
    '#00ced1',
    '#1e90ff',
    '#c71585',
    '#f1b859',
    '#f4994b',
    '#d7394d',
    '#dd5b46',
    '#f7d69e',
  ]
  formAddList = formAddList;
  compontentFormIsShow = false
  formType = {}

  changeFormType(e :any){
    this.formType = e
  }

  public fontFaceList = getFontFaceList([
    {
      name: 'Arial',
      value: 'Arial, sans-serif',
      original: true
    },
    {
      name: 'Courier New',
      value: 'Courier New, monospace',
      original: true
    },
    {
      name: 'Georgia',
      value: 'Georgia, serif',
      original: true
    },
    {
      name: 'Times New Roman',
      value: 'Times New Roman, serif',
      original: true
    },
    {
      name: 'Trebuchet MS',
      value: 'Trebuchet MS, sans-serif',
      original: true
    },
    {
      name: 'Verdana',
      value: 'Verdana, sans-serif',
      original: true
    }
  ]);

  changeFormList(e:any){
    this.formDataStart.end = e 
    this.changeStart()
  }
  changcompontentFormIsShow(e:boolean){
    this.compontentFormIsShow= e
  }


  changeStart(){
    this.$emit('change',this.formDataStart)
  }
  changeEmailOpen(){
    if (this.emailOpen) {
      if(this.formData.rules.emailPosition == 'start'){
        this.$message.warning(this.$tx('form.startPageAlreadyDisplaysUser', '开始页面已经显示用户邮箱'))
        this.emailOpen = false
      }else{
        this.formDataStart.rules.emailPosition = 'end'
        this.formDataStart.rules.emailOpen = this.emailOpen 
      }
    }else{
      if(this.formData.rules.emailPosition == 'start'){
        this.formData.rules.emailPosition = 'start'
      }else{
        this.formData.rules.emailPosition = ''
      }
    }
        this.changeStart()
  }

  changeCouponCodePosition(){
    if (this.couponCodeShow) {
      if(this.formData.rules.couponCodePosition == 'start'){
        this.$message.warning(this.$tx('form.edit.err.startHasCoupon', '开始页面已经展示coupon'))
        this.couponCodeShow = false
      }else{
        this.formDataStart.rules.couponCodePosition = 'end'
        this.formDataStart.rules.couponCodeShow = this.couponCodeShow 
      }
    }else{
      if(this.formData.rules.couponCodePosition == 'start'){
        this.formData.rules.couponCodePosition = 'start'
      }else{
        this.formData.rules.couponCodePosition = ''
      }
    }
        this.changeStart()
  }
  addFormAddList(item:any,index:number){
    if (this.collapseArr.indexOf("1") < 0) {
      this.collapseArr.push('1')
    }
    if(item.type !== '自定义'){
      let a = this.formList.filter((i:any)=>{
        return i.type === item.type
      })

      if(a.length > 0){
        this.formType = a[0]
        this.compontentFormIsShow = true
        return
      }
      let b = this.formDataStart.start.filter((i:any)=>{
        return i.type === item.type
      })
      if(b.length > 0){
        this.$message.error(this.$tx('form.edit.err.dupField', '您添加了多个{{label}}表单，请检查设置是否有误', { label: item.label }))
        return
      }
    }
    if(this.formList.length < 8){
      this.formType = item
      this.compontentFormIsShow = true
    }else{
      this.$message.error(this.$tx('form.edit.err.max8', '最多只能添加8个表单'))
    }
    
  }

  @Watch('formData.rules.emailOpen')
  emailOpenChange(val:boolean){
    if (val == true && this.formData.rules.emailPosition == 'end') {
      this.emailOpen = true
    }
  }

  @Watch('formData.rules.emailPosition')
  emailPositionChange(val:string){
    if (this.formData.rules.emailOpen == true && this.formData.rules.emailPosition == 'end') {
      this.emailOpen = true
    }
  }

  @Watch('formData.rules.couponCodeShow')
  couponCodeShowChange(val:boolean){
    if (val == true && this.formData.rules.couponCodePosition == 'end') {
      this.couponCodeShow = true
    }
  }

  @Watch('formData.rules.couponCodePosition')
  couponCodePositionChange(val:string){
    if (this.formData.rules.couponCodeShow == true && this.formData.rules.couponCodePosition == 'end') {
      this.couponCodeShow = true
    }
  }
  @Watch("formData.end")
  changeEndFormList(val:any){
    this.formList = val
  }

}
